<div
  [ngClass]="{ 'one-up': video?.length === 1, 'two-up': video?.length > 1 }"
  class="jb-video mt4 mb4 mb6-ns jb-grid grid-offset"
  *ngIf="!!video && !!video?.length"
>
  <ng-container *ngFor="let currentVideo of video">
    <jb-video
      [videoId]="currentVideo?.videoId"
      [title]="currentVideo?.title"
      [caption]="currentVideo?.caption"
    >
    </jb-video>
  </ng-container>
</div>
